import React, { Component } from "react";
import PropTypes from "prop-types";
import Rheostat from "rheostat";
import { connectRange } from "react-instantsearch-dom";

class Range extends Component {
    static propTypes = {
        min: PropTypes.number,
        max: PropTypes.number,
        currentRefinement: PropTypes.object,
        refine: PropTypes.func.isRequired,
        canRefine: PropTypes.bool.isRequired,
        sliderMin: PropTypes.number.isRequired,
        sliderMax: PropTypes.number.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            currentValues: {
                min: props.sliderMin,
                max: props.sliderMax
            }
        };
    }

    componentDidMount() {
        const { sliderMin, sliderMax } = this.props;
        const values = { min: sliderMin, max: sliderMax };

        this.setState({ currentValues: values });
    }

    onChange = sliderState => {
        const {
            currentRefinement,
            refine,
            min,
            max,
            sliderMin,
            sliderMax
        } = this.props;
        const values = this.extractValuesFromSliderState(sliderState);

        this.setState({ values });

        if (
            currentRefinement.min !== values.min ||
            currentRefinement.max !== values.max
        ) {
            const refineValues = values;

            if (sliderMin < min) {
                if (refineValues.min < min) {
                    refineValues.min = min;
                }
            } else if (sliderMin > min) {
                if (refineValues.min === sliderMin) {
                    refineValues.min = min;
                }
            }

            if (sliderMax < max) {
                if (refineValues.max === sliderMax) {
                    refineValues.max = max;
                }
            } else if (sliderMax > max) {
                if (refineValues.max > max) {
                    refineValues.max = max;
                }
            }

            refine(refineValues);
        }
    };

    onValuesUpdated = sliderState => {
        const values = this.extractValuesFromSliderState(sliderState);

        this.setState({ currentValues: values });
    };

    extractValuesFromSliderState = ({ values }) => ({
        min: values[0],
        max: values[1]
    });

    render() {
        const { min, max, sliderMin, sliderMax } = this.props;
        const { currentValues } = this.state;

        return (
            <div className="range-slider">
                <Rheostat
                    className="range-slider__slider"
                    min={sliderMin !== undefined ? sliderMin : min}
                    max={sliderMax !== undefined ? sliderMax : max}
                    values={[currentValues.min, currentValues.max]}
                    onChange={this.onChange}
                    onValuesUpdated={this.onValuesUpdated}
                />

                <div className="range-slider__values">
                    <div className="range-slider__value">
                        <span className="range-slider__value-label">Min</span>
                        <span className="range-slider__displayed-value">
                            {currentValues.min}
                        </span>
                    </div>

                    <div className="range-slider__value">
                        <span className="range-slider__value-label">Max</span>
                        <span className="range-slider__displayed-value">
                            {currentValues.max}
                            {currentValues.max === sliderMax && "+"}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

export default connectRange(Range);



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/Range.js